module.exports = __webpack_public_path__ + "img/kp.9c534291.svg";